import React, { useState, useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";

// Material-UI Core
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import InputBase from "@material-ui/core/InputBase";
import { DataGrid } from "@material-ui/data-grid";

// Material-UI Icon
import SearchIcon from "@material-ui/icons/Search";

import TransmittalSelectedRFIDetails from "./TransmittalSelectedRFIDetails";

import { getRFIList } from "../../../dataSource/rfi";

// Custom Style
import { transAtthStyle } from "../../../styles/jss/components/transmittal/transAtthStyle";

const useStyles = makeStyles((theme) => transAtthStyle(theme));
const TransmittalSelectRFI = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { submissionValue, setSubmissionValue, buildAlert } = props;
  const [openDialog, setOpenDialog] = useState(false);
  const [rfiseq, setRfiseq] = useState("");
  const [list, setList] = useState([]);
  const [filterList, setfilterList] = useState([]);
  const [listMsg, setListMsg] = useState("");

  const columns = [
    {
      field: "id",
      hide: "true",
    },
    {
      field: "rfi_seq",
      renderCell: (params) => (
        <Button
          variant="contained"
          color="primary"
          size="small"
          style={{ marginLeft: 16 }}
          onClick={() => showRFIDetails(params)}
        >
          View
        </Button>
      ),
      headerName: " ",
    },
    { field: "ref_no", headerName: "Ref. No.", width: 300 },
    { field: "issue_by", headerName: "Issue By", width: 250 },
    { field: "stage", headerName: "Stage", width: 150 },
    { field: "last_update_date", headerName: "Last Update Date", width: 200 },
  ];
  const getRFIListAction = async () => {
    getRFIList("N").then((res) => {
      let rfilist = res.data.map((obj, index) => {
        return {
          id: ++index,
          ...obj,
        };
      });
      setList(rfilist);
      setfilterList(rfilist);
      if (res.data.length === 0) {
        setListMsg("No RFI");
      } else {
        setListMsg("");
      }
    });
  };
  const showRFIDetails = (params) => {
    setOpenDialog(true);
    setRfiseq(params.value);
  };

  const quickSearch = (event) => {
    const keyWord = event.target.value !== null ? event.target.value : "";
    let filterResult = "";
    filterResult = filterList.filter((obj) =>
      obj.ref_no.toLowerCase().includes(keyWord.toLowerCase())
    );
    setList(filterResult);
  };

  useEffect(() => {
    const fetchRFIList = async () => {
      await getRFIListAction();
    };
    fetchRFIList();
  }, []);

  return (
    <Fragment>
      <Grid item xs={12}>
        {!openDialog && (
          <>
            <Typography variant="subtitle1" className={classes.headerText}>
              Search RFI by Reference No.
            </Typography>
            <Divider className={classes.divider} />

            <div className={classes.searchBar}>
              <div className={classes.search}>
                <div className={classes.searchIcon}>
                  <SearchIcon />
                </div>

                <InputBase
                  onChange={quickSearch}
                  placeholder="Quick Search"
                  classes={{
                    root: classes.inputRoot,
                    input: classes.inputInput,
                  }}
                  inputProps={{ "aria-label": "search" }}
                />
              </div>
            </div>

            <div style={{ width: "100%" }}>
              <DataGrid
                rows={list}
                columns={columns}
                pageSize={10}
                autoHeight={true}
              />
            </div>
          </>
        )}
        {openDialog && (
          <>
            <TransmittalSelectedRFIDetails
              rfiSeq={rfiseq}
              openDialog={openDialog}
              setOpenDialog={setOpenDialog}
              setList={setList}
              filterList={filterList}
              submissionValue={submissionValue}
              setSubmissionValue={setSubmissionValue}
              buildAlert={buildAlert}
            />
          </>
        )}
      </Grid>
    </Fragment>
  );
};

export default TransmittalSelectRFI;
